import { render, staticRenderFns } from "./FieldSet.vue?vue&type=template&id=067a0e1e"
import script from "./FieldSet.vue?vue&type=script&lang=js"
export * from "./FieldSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports